import { render, staticRenderFns } from "./changeStatusModel.vue?vue&type=template&id=01a993a6&scoped=true&"
import script from "./changeStatusModel.vue?vue&type=script&lang=js&"
export * from "./changeStatusModel.vue?vue&type=script&lang=js&"
import style0 from "./changeStatusModel.vue?vue&type=style&index=0&id=01a993a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a993a6",
  null
  
)

export default component.exports